import React, {useEffect, useState, useContext, useRef} from 'react';
import {useHistory} from 'react-router-dom';
import {t, getLanguage} from 'react-switch-lang';
import {format, parseISO} from 'date-fns';
import Badge from 'react-bootstrap/Badge';
import {AsyncPaginate} from 'react-select-async-paginate';
import '../Dashboard.scss';
import {
  getDepartments,
} from '../../../services/dashboard/DashboardApi';
import http from '../../../services/httpService';
import {getDepartmentsCurrentUser} from '../../../services/accountService';
import {getRiskColor} from '../../../utils/helpers';
import {DepartmentContext} from '../../../contexts/DepartmentContext';
import {UserContext} from '../../../contexts/UserContext';
import NoFormTable from '../../../components/customTable/NoFormTable';
import roles from '../../../utils/roles';
import {incurredRiskId, potentialRiskId} from "../../../utils/const";

const First = () => {
  const dataDepartment = useContext(DepartmentContext);
  const user = useContext(UserContext);
  const lang = getLanguage();
  const history = useHistory();
  const [departments, setDepartments] = useState();
  const [departmentsFilter, setDepartmentsFilter] = useState([]);

  const [riskTypeId, setRiskTypeId] = useState({value: '', label: ''});
  const [defaultDepartment, setDefaultDepartment] = useState([]);
  const [userAuthorities, setUserAuthorities] = useState(user.authorities);
  const [potentionalOccured, setPotentionalOccured] = useState(true);

  const queryKeys =
    getLanguage() === 'eng' ? 'nameEn.contains' : 'name.contains';

  const api = useRef();

  const userSuperAdmin = userAuthorities.some((r) =>
    r.includes(roles.role_super_admin)
  );
  const userRiskSector = userAuthorities.some((r) =>
    r.includes(roles.role_risk_sector)
  );


  const columns = [
    {
      key: 'id',
      dataIndex: 'id',
      title: t('last-potential-incurred.operationalRiskId'),
    },
    ...(riskTypeId?.value === 2
        ? [
          {
            key: 'potentialRiskId',
            dataIndex: 'potentialRiskId',
            title: t('risk-cosideration.potentialRiskId'),
            ellipsis:true
          },
        ]
        : []),
    {
      key: 'title',
      dataIndex: 'title',
      title: t('last-potential-incurred.operationalRiskName'),
    },
    {
      key: 'riskStatusName',
      dataIndex: getLanguage() === 'mne' ? 'riskStatusName' : 'riskStatusNameEn',
      title: t('last-potential-incurred.operationalRiskStatus'),
    },
    {
      key: 'riskEstimationId',
      dataIndex: 'riskEstimationId',
      title: t('last-potential-incurred.rating'),
      render: (dataIndex) => (
        <span
          style={
            dataIndex < 5
              ? {color: '#37C35C', fontWeight: 'bold'}
              : dataIndex >= 5 && dataIndex <= 10
              ? {color: '#F59A1F', fontWeight: 'bold'}
              : {color: '#F5501F', fontWeight: 'bold'}
          }
        >
          {dataIndex}
        </span>
      ),
    },
    {
      key: 'applicationDate',
      dataIndex: 'applicationDate',
      title: t('last-potential-incurred.creationDate'),
      render: (dataIndex) => (
        <span> {format(parseISO(dataIndex), 'dd.MM.yyyy.')}</span>
      ),
    },
    {
      key: 'riskEstimationEvaluation',
      dataIndex:getLanguage() === 'mne' ? 'riskEstimationEvaluation' : 'riskEstimationEvaluationEn',
      title: t('last-potential-incurred.status'),
      render: (dataIndex) => (
        <Badge className={'tableBadge'} variant={getRiskColor(dataIndex)} >{dataIndex}</Badge>
      ),
    },
    {
      key: 'value',
      title: t('last-potential-incurred.userCreated'),
      render: (request) => {
        return `${request.userCreatedFirstName} ${request.userCreatedLastName}`
      }
    },
  ];

  const getDepartmentList = async (query) => {
    let options = [];
    try {
      if (query) {
        const {data} = await http.get(`/departments?${queryKeys}=${query}`);
        options = data;
      } else {
        const {data} = await getDepartments();
        options = data;
      }
    } catch (err) {
      // console.log(err);
    }
    return {
      options: options.map((option) => ({
        value: option.id,
        label: lang === 'mne' ? option.name : option.nameEn,
      })),
    };
  };

  const getDepartmentAllowedList = async (query) => {
    let options = [];
    try {
      if(query){
        const {data} = await http.get(`/departments-login-user?${queryKeys}=${query}`);
        options = data;
      } else {
        const {data} = await getDepartmentsCurrentUser();
        options = data;
      }
      
    } catch (err) {
      // console.log(err);
    }

    return {
      options: options.map((option) => ({
        value: option.id,
        label: lang === 'mne' ? option.name : option.nameEn,
      })),
    };
  };

  const getRiskType = async (query) => {
    let options = [];
    try {
      if (query) {
        const {data} = await http.get(
          `risk-types?id.notEquals=3&${queryKeys}=${query}`
        );
        setRiskTypeId({
          value: data[0].id,
          label: lang === 'mne' ? data[0].name : data[0].nameEn,
        });
        options = data;
      } else {
        const {data} = await http.get(`risk-types?id.notEquals=3`);
        setRiskTypeId({
          value: data[0].id,
          label: lang === 'mne' ? data[0].name : data[0].nameEn,
        });
        options = data;
      }
    } catch (err) {
      // console.log(err);
    }
    return {
      options: options.map((option) => ({
        value: option.id,
        label: lang === 'mne' ? option.name : option.nameEn,
      })),
    };
  };

  useEffect(() => {
    const arr = [];
    const arrQ = [];
    dataDepartment.map((item, idx) => {
      arrQ.push(item.id);
      arr.push({
        value: item.id,
        label: lang === 'mne' ? item.name : item.nameEn,
      });
    });
    setDefaultDepartment(arr);
    setDepartments(arr);
    if (arrQ.length > 0) {
      api.current = `/risks/last-potential-incurred?riskTypeId=1&department=${arrQ.join(
        ','
      )}&size=10`;
    } else {
      api.current = `/risks/last-potential-incurred?riskTypeId=1&size=10`;
    }
  }, []);

  useEffect(() => {
    getRiskType();
  }, []);

  useEffect(() => {
    setDepartments(defaultDepartment);
  }, [riskTypeId]);

  const onChangeRiskType = (e) => {
    setRiskTypeId(e);
    if (e.value) {
      api.current = `/risks/last-potential-incurred?department=${departmentsFilter}&riskTypeId=${e.value}&size=10`;
    }
    if (e.value === 1) {
      api.current = `/risks/last-potential-incurred?departmentId=${departmentsFilter}&riskTypeId=${e.value}&size=10`;
      setPotentionalOccured(false);
    } else if (e.value === 2) {
      setDepartments(defaultDepartment);
      api.current = `/risks/last-potential-incurred?departmentId=${departmentsFilter}&riskTypeId=${e.value}&size=10`;
    }
  };
  const onChangeDepartment = (e) => {
    setDepartments(e);
    if (e?.length && riskTypeId) {
      let arr = [];
      e.map((i) => {
        arr.push(i.value);
      });
      arr.join(',');
      api.current = `/risks/last-potential-incurred?department=${arr}&riskTypeId=${riskTypeId.value}&size=10`;
    } else if (!e?.length && riskTypeId) {
      api.current = `/risks/last-potential-incurred?riskTypeId=${riskTypeId.value}&size=10`;
    }
  };

  useEffect(() => {
    if (riskTypeId?.value === incurredRiskId && !userSuperAdmin && !userRiskSector) {
      setPotentionalOccured(false);
    } else if (riskTypeId?.value === potentialRiskId) {
      setPotentionalOccured(true);
    }
  }, [riskTypeId]);

  const toSingleRisk = (id) => {
    if (riskTypeId && riskTypeId.value === potentialRiskId) {
      history.push(`/potential-risk/${id}`);
    } else if (riskTypeId && riskTypeId.value === incurredRiskId) {
      history.push(`/incurred-risk/${id}`);
    }
  };

  return (
    <>
      <div className="dashboardSelect">
        <AsyncPaginate
          name="riskTypeId"
          value={riskTypeId}
          onChange={(e) => onChangeRiskType(e)}
          loadOptions={getRiskType}
          noOptionsMessage={() => t('table.no-data')}
          loadingMessage={() => t('message.loading')}
          placeholder={t('risks.riskTypePlaceholder')}
          debounceTimeout={300}
        />
      </div>
      <div className="dashboardSelect">
        {potentionalOccured ? (
          <AsyncPaginate
            name="departmentId"
            value={departments}
            onChange={(e) => onChangeDepartment(e)}
            loadOptions={getDepartmentList}
            noOptionsMessage={() => t('table.no-data')}
            loadingMessage={() => t('message.loading')}
            placeholder={t('risks.departmentPlaceholder')}
            debounceTimeout={300}
            isMulti={true}
            isClearable={true}
            key={potentionalOccured}
            components={{IndicatorSeparator: () => null}}
          />
        ) : (
          <AsyncPaginate
            name="departmentId"
            value={departments}
            onChange={(e) => onChangeDepartment(e)}
            loadOptions={getDepartmentAllowedList}
            noOptionsMessage={() => t('table.no-data')}
            loadingMessage={() => t('message.loading')}
            placeholder={t('risks.departmentPlaceholder')}
            debounceTimeout={300}
            isMulti={true}
            isClearable={true}
            key={potentionalOccured}
            components={{IndicatorSeparator: () => null}}
          />
        )}
      </div>
      <NoFormTable
        api={api.current}
        columns={columns}
        onRowClick={toSingleRisk}
        className={'table-hover'}
      />
    </>
  );
};

export default First;
